import React, { useMemo } from 'react';
import styled from 'styled-components';
import { selectLocale } from 'models/localization';
import { DesignCanvasLayer } from 'models/cms/booths';
import { useSelector } from 'react-redux';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import StyledContainer from '../styled';

const ImageContainer = styled.img`
  width: 100%;
  height: 100%;
`;

interface ElementProps {
  layer: DesignCanvasLayer;
  onElementClick: () => void;
}

const Element: React.FC<ElementProps> = ({
  layer,
  onElementClick,
}: ElementProps) => {
  const locale = useSelector(selectLocale);
  const imageUrl: string = useMemo(() => findAvailableLocale(layer?.image, locale)?.originalImageUrl, [layer?.image, locale]);
  const {
    positionX, positionY, height, width,
  } = layer;

  return !!imageUrl && (
    <StyledContainer width={width} height={height} positionX={positionX} positionY={positionY} onClick={onElementClick}>
      <ImageContainer src={imageUrl} />
    </StyledContainer>
  );
};

export default Element;
